import api from "../index";

export default {
  async show(id, country, option, quantity, region) {
    const params = region ? { region } : {};

    if (option) {
      return api.get(
        `/shipping/calculator/${id}/${country}/${quantity}/${option}`,
        { params }
      );
    }
    if (quantity) {
      return api.get(`/shipping/calculator/${id}/${country}/${quantity}`, {
        params
      });
    }

    return api.get(`/shipping/calculator/${id}/${country}`, { params });
  }
};
